import {Triangle} from "react-loader-spinner";
import {LoaderContainer} from "../../styles/Styles";

const Loader = () => {
    return <LoaderContainer>
        <Triangle
            visible={true}
            height="80"
            width="80"
            color="#4fa94d"
            ariaLabel="triangle-loading"
            wrapperStyle={{}}
            wrapperClass=""
        />
    </LoaderContainer>
}

export default Loader;
